import { AbstractDTO } from "./abstract";
import { IHomePageCms } from "@signature-it/ngx-generic/interfaces";

/**
 * Created by shani on 14/09/17.
 */
export class HomePageCms extends AbstractDTO implements IHomePageCms{

    top: string;
    bottom: string;
    left: string;
    right: string;

    constructor(attributes: Object) {
        super(attributes);
        this.top = attributes['top'];
        this.bottom = attributes['bottom'];
        this.left = attributes['left'];
        this.right = attributes['right'];
    }
}
